export const normalDistribuition = {
  xAxis: [
    0, 0.001, 0.002, 0.003, 0.004, 0.005, 0.006, 0.007, 0.008, 0.009, 0.01,
    0.011, 0.012, 0.013, 0.014, 0.015, 0.016, 0.017, 0.018, 0.019, 0.02, 0.021,
    0.022, 0.023, 0.024, 0.025, 0.026, 0.027, 0.028, 0.029, 0.03, 0.031, 0.032,
    0.033, 0.034, 0.035, 0.036, 0.037, 0.038, 0.039, 0.04, 0.041, 0.042, 0.043,
    0.044, 0.045, 0.046, 0.047, 0.048, 0.049, 0.05, 0.051, 0.052, 0.053, 0.054,
    0.055, 0.056, 0.057, 0.058, 0.059, 0.06, 0.061, 0.062, 0.063, 0.064, 0.065,
    0.066, 0.067, 0.068, 0.069, 0.07, 0.071, 0.072, 0.073, 0.074, 0.075, 0.076,
    0.077, 0.078, 0.079, 0.08, 0.081, 0.082, 0.083, 0.084, 0.085, 0.086, 0.087,
    0.088, 0.089, 0.09, 0.091, 0.092, 0.093, 0.094, 0.095, 0.096, 0.097, 0.098,
    0.099, 0.1, 0.101, 0.102, 0.103, 0.104, 0.105, 0.106, 0.107, 0.108, 0.109,
    0.11, 0.111, 0.112, 0.113, 0.114, 0.115, 0.116, 0.117, 0.118, 0.119, 0.12,
    0.121, 0.122, 0.123, 0.124, 0.125, 0.126, 0.127, 0.128, 0.129, 0.13, 0.131,
    0.132, 0.133, 0.134, 0.135, 0.136, 0.137, 0.138, 0.139, 0.14, 0.141, 0.142,
    0.143, 0.144, 0.145, 0.146, 0.147, 0.148, 0.149, 0.15, 0.151, 0.152, 0.153,
    0.154, 0.155, 0.156, 0.157, 0.158, 0.159, 0.16, 0.161, 0.162, 0.163, 0.164,
    0.165, 0.166, 0.167, 0.168, 0.169, 0.17, 0.171, 0.172, 0.173, 0.174, 0.175,
    0.176, 0.177, 0.178, 0.179, 0.18, 0.181, 0.182, 0.183, 0.184, 0.185, 0.186,
    0.187, 0.188, 0.189, 0.19, 0.191, 0.192, 0.193, 0.194, 0.195, 0.196, 0.197,
    0.198, 0.199, 0.2, 0.201, 0.202, 0.203, 0.204, 0.205, 0.206, 0.207, 0.208,
    0.209, 0.21, 0.211, 0.212, 0.213, 0.214, 0.215, 0.216, 0.217, 0.218, 0.219,
    0.22, 0.221, 0.222, 0.223, 0.224, 0.225, 0.226, 0.227, 0.228, 0.229, 0.23,
    0.231, 0.232, 0.233, 0.234, 0.235, 0.236, 0.237, 0.238, 0.239, 0.24, 0.241,
    0.242, 0.243, 0.244, 0.245, 0.246, 0.247, 0.248, 0.249, 0.25, 0.251, 0.252,
    0.253, 0.254, 0.255, 0.256, 0.257, 0.258, 0.259, 0.26, 0.261, 0.262, 0.263,
    0.264, 0.265, 0.266, 0.267, 0.268, 0.269, 0.27, 0.271, 0.272, 0.273, 0.274,
    0.275, 0.276, 0.277, 0.278, 0.279, 0.28, 0.281, 0.282, 0.283, 0.284, 0.285,
    0.286, 0.287, 0.288, 0.289, 0.29, 0.291, 0.292, 0.293, 0.294, 0.295, 0.296,
    0.297, 0.298, 0.299, 0.3, 0.301, 0.302, 0.303, 0.304, 0.305, 0.306, 0.307,
    0.308, 0.309, 0.31, 0.311, 0.312, 0.313, 0.314, 0.315, 0.316, 0.317, 0.318,
    0.319, 0.32, 0.321, 0.322, 0.323, 0.324, 0.325, 0.326, 0.327, 0.328, 0.329,
    0.33, 0.331, 0.332, 0.333, 0.334, 0.335, 0.336, 0.337, 0.338, 0.339, 0.34,
    0.341, 0.342, 0.343, 0.344, 0.345, 0.346, 0.347, 0.348, 0.349, 0.35, 0.351,
    0.352, 0.353, 0.354, 0.355, 0.356, 0.357, 0.358, 0.359, 0.36, 0.361, 0.362,
    0.363, 0.364, 0.365, 0.366, 0.367, 0.368, 0.369, 0.37, 0.371, 0.372, 0.373,
    0.374, 0.375, 0.376, 0.377, 0.378, 0.379, 0.38, 0.381, 0.382, 0.383, 0.384,
    0.385, 0.386, 0.387, 0.388, 0.389, 0.39, 0.391, 0.392, 0.393, 0.394, 0.395,
    0.396, 0.397, 0.398, 0.399, 0.4, 0.401, 0.402, 0.403, 0.404, 0.405, 0.406,
    0.407, 0.408, 0.409, 0.41, 0.411, 0.412, 0.413, 0.414, 0.415, 0.416, 0.417,
    0.418, 0.419, 0.42, 0.421, 0.422, 0.423, 0.424, 0.425, 0.426, 0.427, 0.428,
    0.429, 0.43, 0.431, 0.432, 0.433, 0.434, 0.435, 0.436, 0.437, 0.438, 0.439,
    0.44, 0.441, 0.442, 0.443, 0.444, 0.445, 0.446, 0.447, 0.448, 0.449, 0.45,
    0.451, 0.452, 0.453, 0.454, 0.455, 0.456, 0.457, 0.458, 0.459, 0.46, 0.461,
    0.462, 0.463, 0.464, 0.465, 0.466, 0.467, 0.468, 0.469, 0.47, 0.471, 0.472,
    0.473, 0.474, 0.475, 0.476, 0.477, 0.478, 0.479, 0.48, 0.481, 0.482, 0.483,
    0.484, 0.485, 0.486, 0.487, 0.488, 0.489, 0.49, 0.491, 0.492, 0.493, 0.494,
    0.495, 0.496, 0.497, 0.498, 0.499, 0.5, 0.501, 0.502, 0.503, 0.504, 0.505,
    0.506, 0.507, 0.508, 0.509, 0.51, 0.511, 0.512, 0.513, 0.514, 0.515, 0.516,
    0.517, 0.518, 0.519, 0.52, 0.521, 0.522, 0.523, 0.524, 0.525, 0.526, 0.527,
    0.528, 0.529, 0.53, 0.531, 0.532, 0.533, 0.534, 0.535, 0.536, 0.537, 0.538,
    0.539, 0.54, 0.541, 0.542, 0.543, 0.544, 0.545, 0.546, 0.547, 0.548, 0.549,
    0.55, 0.551, 0.552, 0.553, 0.554, 0.555, 0.556, 0.557, 0.558, 0.559, 0.56,
    0.561, 0.562, 0.563, 0.564, 0.565, 0.566, 0.567, 0.568, 0.569, 0.57, 0.571,
    0.572, 0.573, 0.574, 0.575, 0.576, 0.577, 0.578, 0.579, 0.58, 0.581, 0.582,
    0.583, 0.584, 0.585, 0.586, 0.587, 0.588, 0.589, 0.59, 0.591, 0.592, 0.593,
    0.594, 0.595, 0.596, 0.597, 0.598, 0.599, 0.6, 0.601, 0.602, 0.603, 0.604,
    0.605, 0.606, 0.607, 0.608, 0.609, 0.61, 0.611, 0.612, 0.613, 0.614, 0.615,
    0.616, 0.617, 0.618, 0.619, 0.62, 0.621, 0.622, 0.623, 0.624, 0.625, 0.626,
    0.627, 0.628, 0.629, 0.63, 0.631, 0.632, 0.633, 0.634, 0.635, 0.636, 0.637,
    0.638, 0.639, 0.64, 0.641, 0.642, 0.643, 0.644, 0.645, 0.646, 0.647, 0.648,
    0.649, 0.65, 0.651, 0.652, 0.653, 0.654, 0.655, 0.656, 0.657, 0.658, 0.659,
    0.66, 0.661, 0.662, 0.663, 0.664, 0.665, 0.666, 0.667, 0.668, 0.669, 0.67,
    0.671, 0.672, 0.673, 0.674, 0.675, 0.676, 0.677, 0.678, 0.679, 0.68, 0.681,
    0.682, 0.683, 0.684, 0.685, 0.686, 0.687, 0.688, 0.689, 0.69, 0.691, 0.692,
    0.693, 0.694, 0.695, 0.696, 0.697, 0.698, 0.699, 0.7, 0.701, 0.702, 0.703,
    0.704, 0.705, 0.706, 0.707, 0.708, 0.709, 0.71, 0.711, 0.712, 0.713, 0.714,
    0.715, 0.716, 0.717, 0.718, 0.719, 0.72, 0.721, 0.722, 0.723, 0.724, 0.725,
    0.726, 0.727, 0.728, 0.729, 0.73, 0.731, 0.732, 0.733, 0.734, 0.735, 0.736,
    0.737, 0.738, 0.739, 0.74, 0.741, 0.742, 0.743, 0.744, 0.745, 0.746, 0.747,
    0.748, 0.749, 0.75, 0.751, 0.752, 0.753, 0.754, 0.755, 0.756, 0.757, 0.758,
    0.759, 0.76, 0.761, 0.762, 0.763, 0.764, 0.765, 0.766, 0.767, 0.768, 0.769,
    0.77, 0.771, 0.772, 0.773, 0.774, 0.775, 0.776, 0.777, 0.778, 0.779, 0.78,
    0.781, 0.782, 0.783, 0.784, 0.785, 0.786, 0.787, 0.788, 0.789, 0.79, 0.791,
    0.792, 0.793, 0.794, 0.795, 0.796, 0.797, 0.798, 0.799, 0.8, 0.801, 0.802,
    0.803, 0.804, 0.805, 0.806, 0.807, 0.808, 0.809, 0.81, 0.811, 0.812, 0.813,
    0.814, 0.815, 0.816, 0.817, 0.818, 0.819, 0.82, 0.821, 0.822, 0.823, 0.824,
    0.825, 0.826, 0.827, 0.828, 0.829, 0.83, 0.831, 0.832, 0.833, 0.834, 0.835,
    0.836, 0.837, 0.838, 0.839, 0.84, 0.841, 0.842, 0.843, 0.844, 0.845, 0.846,
    0.847, 0.848, 0.849, 0.85, 0.851, 0.852, 0.853, 0.854, 0.855, 0.856, 0.857,
    0.858, 0.859, 0.86, 0.861, 0.862, 0.863, 0.864, 0.865, 0.866, 0.867, 0.868,
    0.869, 0.87, 0.871, 0.872, 0.873, 0.874, 0.875, 0.876, 0.877, 0.878, 0.879,
    0.88, 0.881, 0.882, 0.883, 0.884, 0.885, 0.886, 0.887, 0.888, 0.889, 0.89,
    0.891, 0.892, 0.893, 0.894, 0.895, 0.896, 0.897, 0.898, 0.899, 0.9, 0.901,
    0.902, 0.903, 0.904, 0.905, 0.906, 0.907, 0.908, 0.909, 0.91, 0.911, 0.912,
    0.913, 0.914, 0.915, 0.916, 0.917, 0.918, 0.919, 0.92, 0.921, 0.922, 0.923,
    0.924, 0.925, 0.926, 0.927, 0.928, 0.929, 0.93, 0.931, 0.932, 0.933, 0.934,
    0.935, 0.936, 0.937, 0.938, 0.939, 0.94, 0.941, 0.942, 0.943, 0.944, 0.945,
    0.946, 0.947, 0.948, 0.949, 0.95, 0.951, 0.952, 0.953, 0.954, 0.955, 0.956,
    0.957, 0.958, 0.959, 0.96, 0.961, 0.962, 0.963, 0.964, 0.965, 0.966, 0.967,
    0.968, 0.969, 0.97, 0.971, 0.972, 0.973, 0.974, 0.975, 0.976, 0.977, 0.978,
    0.979, 0.98, 0.981, 0.982, 0.983, 0.984, 0.985, 0.986, 0.987, 0.988, 0.989,
    0.99, 0.991, 0.992, 0.993, 0.994, 0.995, 0.996, 0.997, 0.998, 0.999,
  ],
  yAxis: [
    0.00336709, 0.00343202, 0.00349806, 0.00356524, 0.00363357, 0.00370307,
    0.00377375, 0.00384563, 0.00391874, 0.00399308, 0.00406867, 0.00414554,
    0.0042237, 0.00430317, 0.00438396, 0.0044661, 0.00454961, 0.0046345,
    0.00472079, 0.0048085, 0.00489766, 0.00498828, 0.00508038, 0.00517399,
    0.00526911, 0.00536579, 0.00546402, 0.00556384, 0.00566527, 0.00576833,
    0.00587303, 0.00597941, 0.00608748, 0.00619727, 0.00630879, 0.00642208,
    0.00653715, 0.00665403, 0.00677274, 0.0068933, 0.00701574, 0.00714009,
    0.00726635, 0.00739457, 0.00752476, 0.00765695, 0.00779117, 0.00792743,
    0.00806577, 0.00820621, 0.00834878, 0.00849349, 0.00864039, 0.00878949,
    0.00894081, 0.0090944, 0.00925027, 0.00940845, 0.00956897, 0.00973186,
    0.00989714, 0.01006484, 0.010235, 0.01040763, 0.01058276, 0.01076044,
    0.01094067, 0.0111235, 0.01130895, 0.01149706, 0.01168784, 0.01188134,
    0.01207758, 0.01227659, 0.0124784, 0.01268304, 0.01289055, 0.01310094,
    0.01331427, 0.01353055, 0.01374981, 0.0139721, 0.01419743, 0.01442585,
    0.01465738, 0.01489205, 0.01512991, 0.01537097, 0.01561528, 0.01586287,
    0.01611376, 0.016368, 0.01662561, 0.01688662, 0.01715108, 0.01741902,
    0.01769046, 0.01796544, 0.01824401, 0.01852618, 0.01881199, 0.01910149,
    0.01939469, 0.01969165, 0.01999238, 0.02029693, 0.02060533, 0.02091762,
    0.02123383, 0.02155399, 0.02187814, 0.02220632, 0.02253856, 0.02287489,
    0.02321535, 0.02355998, 0.02390881, 0.02426188, 0.02461921, 0.02498086,
    0.02534684, 0.02571721, 0.02609198, 0.02647121, 0.02685492, 0.02724314,
    0.02763593, 0.0280333, 0.0284353, 0.02884195, 0.02925331, 0.0296694,
    0.03009025, 0.0305159, 0.03094639, 0.03138176, 0.03182203, 0.03226724,
    0.03271742, 0.03317262, 0.03363287, 0.03409819, 0.03456863, 0.03504422,
    0.035525, 0.03601099, 0.03650223, 0.03699876, 0.0375006, 0.0380078,
    0.03852038, 0.03903838, 0.03956184, 0.04009077, 0.04062523, 0.04116523,
    0.04171082, 0.04226201, 0.04281886, 0.04338138, 0.04394961, 0.04452357,
    0.04510331, 0.04568884, 0.04628021, 0.04687744, 0.04748055, 0.04808959,
    0.04870457, 0.04932553, 0.04995249, 0.05058549, 0.05122455, 0.05186969,
    0.05252095, 0.05317835, 0.05384192, 0.05451169, 0.05518767, 0.0558699,
    0.05655839, 0.05725318, 0.05795429, 0.05866174, 0.05937554, 0.06009574,
    0.06082234, 0.06155537, 0.06229486, 0.06304081, 0.06379325, 0.06455221,
    0.06531769, 0.06608972, 0.06686832, 0.06765349, 0.06844527, 0.06924367,
    0.0700487, 0.07086037, 0.07167871, 0.07250372, 0.07333542, 0.07417382,
    0.07501894, 0.07587078, 0.07672935, 0.07759468, 0.07846675, 0.0793456,
    0.08023121, 0.0811236, 0.08202278, 0.08292876, 0.08384153, 0.0847611,
    0.08568748, 0.08662067, 0.08756067, 0.08850748, 0.08946111, 0.09042155,
    0.0913888, 0.09236287, 0.09334374, 0.09433142, 0.09532591, 0.09632719,
    0.09733526, 0.09835012, 0.09937175, 0.10040016, 0.10143532, 0.10247724,
    0.1035259, 0.10458128, 0.10564338, 0.10671218, 0.10778767, 0.10886983,
    0.10995865, 0.1110541, 0.11215618, 0.11326486, 0.11438012, 0.11550194,
    0.11663029, 0.11776517, 0.11890653, 0.12005437, 0.12120864, 0.12236933,
    0.1235364, 0.12470983, 0.12588959, 0.12707565, 0.12826797, 0.12946652,
    0.13067127, 0.13188218, 0.13309922, 0.13432235, 0.13555153, 0.13678673,
    0.1380279, 0.13927499, 0.14052798, 0.14178681, 0.14305145, 0.14432184,
    0.14559793, 0.14687969, 0.14816707, 0.14946, 0.15075845, 0.15206236,
    0.15337167, 0.15468634, 0.15600631, 0.15733151, 0.1586619, 0.15999742,
    0.161338, 0.16268359, 0.16403413, 0.16538954, 0.16674977, 0.16811476,
    0.16948443, 0.17085872, 0.17223756, 0.17362088, 0.17500862, 0.17640069,
    0.17779703, 0.17919757, 0.18060223, 0.18201093, 0.1834236, 0.18484015,
    0.18626052, 0.18768462, 0.18911237, 0.19054369, 0.19197849, 0.19341669,
    0.19485821, 0.19630296, 0.19775085, 0.1992018, 0.20065571, 0.2021125,
    0.20357207, 0.20503434, 0.2064992, 0.20796657, 0.20943635, 0.21090845,
    0.21238276, 0.2138592, 0.21533766, 0.21681803, 0.21830023, 0.21978416,
    0.22126969, 0.22275675, 0.22424521, 0.22573498, 0.22722595, 0.22871801,
    0.23021106, 0.23170499, 0.23319969, 0.23469504, 0.23619095, 0.23768729,
    0.23918395, 0.24068083, 0.24217781, 0.24367477, 0.2451716, 0.24666818,
    0.2481644, 0.24966014, 0.25115528, 0.25264971, 0.2541433, 0.25563593,
    0.25712749, 0.25861785, 0.2601069, 0.26159451, 0.26308055, 0.26456492,
    0.26604747, 0.26752809, 0.26900666, 0.27048304, 0.27195712, 0.27342876,
    0.27489785, 0.27636425, 0.27782784, 0.2792885, 0.28074608, 0.28220047,
    0.28365154, 0.28509916, 0.2865432, 0.28798353, 0.28942002, 0.29085254,
    0.29228097, 0.29370517, 0.29512502, 0.29654038, 0.29795112, 0.29935712,
    0.30075824, 0.30215435, 0.30354532, 0.30493103, 0.30631134, 0.30768612,
    0.30905524, 0.31041857, 0.31177598, 0.31312734, 0.31447253, 0.3158114,
    0.31714384, 0.3184697, 0.31978887, 0.32110122, 0.32240661, 0.32370492,
    0.32499601, 0.32627977, 0.32755606, 0.32882476, 0.33008574, 0.33133887,
    0.33258402, 0.33382108, 0.33504992, 0.33627041, 0.33748243, 0.33868585,
    0.33988056, 0.34106643, 0.34224333, 0.34341115, 0.34456977, 0.34571906,
    0.34685891, 0.3479892, 0.34910981, 0.35022063, 0.35132153, 0.3524124,
    0.35349313, 0.35456361, 0.35562371, 0.35667333, 0.35771236, 0.35874068,
    0.35975819, 0.36076478, 0.36176034, 0.36274476, 0.36371794, 0.36467977,
    0.36563015, 0.36656897, 0.36749615, 0.36841156, 0.36931512, 0.37020672,
    0.37108628, 0.37195369, 0.37280885, 0.37365168, 0.37448208, 0.37529997,
    0.37610524, 0.37689781, 0.3776776, 0.37844452, 0.37919848, 0.3799394,
    0.3806672, 0.3813818, 0.38208311, 0.38277106, 0.38344558, 0.38410658,
    0.38475399, 0.38538774, 0.38600776, 0.38661399, 0.38720634, 0.38778476,
    0.38834918, 0.38889953, 0.38943576, 0.38995781, 0.3904656, 0.3909591,
    0.39143823, 0.39190296, 0.39235321, 0.39278895, 0.39321013, 0.39361669,
    0.39400859, 0.39438578, 0.39474823, 0.39509588, 0.39542871, 0.39574667,
    0.39604973, 0.39633785, 0.396611, 0.39686914, 0.39711226, 0.39734031,
    0.39755328, 0.39775114, 0.39793387, 0.39810144, 0.39825384, 0.39839106,
    0.39851306, 0.39861985, 0.3987114, 0.39878771, 0.39884877, 0.39889457,
    0.3989251, 0.39894037, 0.39894037, 0.3989251, 0.39889457, 0.39884877,
    0.39878771, 0.3987114, 0.39861985, 0.39851306, 0.39839106, 0.39825384,
    0.39810144, 0.39793387, 0.39775114, 0.39755328, 0.39734031, 0.39711226,
    0.39686914, 0.396611, 0.39633785, 0.39604973, 0.39574667, 0.39542871,
    0.39509588, 0.39474823, 0.39438578, 0.39400859, 0.39361669, 0.39321013,
    0.39278895, 0.39235321, 0.39190296, 0.39143823, 0.3909591, 0.3904656,
    0.38995781, 0.38943576, 0.38889953, 0.38834918, 0.38778476, 0.38720634,
    0.38661399, 0.38600776, 0.38538774, 0.38475399, 0.38410658, 0.38344558,
    0.38277106, 0.38208311, 0.3813818, 0.3806672, 0.3799394, 0.37919848,
    0.37844452, 0.3776776, 0.37689781, 0.37610524, 0.37529997, 0.37448208,
    0.37365168, 0.37280885, 0.37195369, 0.37108628, 0.37020672, 0.36931512,
    0.36841156, 0.36749615, 0.36656897, 0.36563015, 0.36467977, 0.36371794,
    0.36274476, 0.36176034, 0.36076478, 0.35975819, 0.35874068, 0.35771236,
    0.35667333, 0.35562371, 0.35456361, 0.35349313, 0.3524124, 0.35132153,
    0.35022063, 0.34910981, 0.3479892, 0.34685891, 0.34571906, 0.34456977,
    0.34341115, 0.34224333, 0.34106643, 0.33988056, 0.33868585, 0.33748243,
    0.33627041, 0.33504992, 0.33382108, 0.33258402, 0.33133887, 0.33008574,
    0.32882476, 0.32755606, 0.32627977, 0.32499601, 0.32370492, 0.32240661,
    0.32110122, 0.31978887, 0.3184697, 0.31714384, 0.3158114, 0.31447253,
    0.31312734, 0.31177598, 0.31041857, 0.30905524, 0.30768612, 0.30631134,
    0.30493103, 0.30354532, 0.30215435, 0.30075824, 0.29935712, 0.29795112,
    0.29654038, 0.29512502, 0.29370517, 0.29228097, 0.29085254, 0.28942002,
    0.28798353, 0.2865432, 0.28509916, 0.28365154, 0.28220047, 0.28074608,
    0.2792885, 0.27782784, 0.27636425, 0.27489785, 0.27342876, 0.27195712,
    0.27048304, 0.26900666, 0.26752809, 0.26604747, 0.26456492, 0.26308055,
    0.26159451, 0.2601069, 0.25861785, 0.25712749, 0.25563593, 0.2541433,
    0.25264971, 0.25115528, 0.24966014, 0.2481644, 0.24666818, 0.2451716,
    0.24367477, 0.24217781, 0.24068083, 0.23918395, 0.23768729, 0.23619095,
    0.23469504, 0.23319969, 0.23170499, 0.23021106, 0.22871801, 0.22722595,
    0.22573498, 0.22424521, 0.22275675, 0.22126969, 0.21978416, 0.21830023,
    0.21681803, 0.21533766, 0.2138592, 0.21238276, 0.21090845, 0.20943635,
    0.20796657, 0.2064992, 0.20503434, 0.20357207, 0.2021125, 0.20065571,
    0.1992018, 0.19775085, 0.19630296, 0.19485821, 0.19341669, 0.19197849,
    0.19054369, 0.18911237, 0.18768462, 0.18626052, 0.18484015, 0.1834236,
    0.18201093, 0.18060223, 0.17919757, 0.17779703, 0.17640069, 0.17500862,
    0.17362088, 0.17223756, 0.17085872, 0.16948443, 0.16811476, 0.16674977,
    0.16538954, 0.16403413, 0.16268359, 0.161338, 0.15999742, 0.1586619,
    0.15733151, 0.15600631, 0.15468634, 0.15337167, 0.15206236, 0.15075845,
    0.14946, 0.14816707, 0.14687969, 0.14559793, 0.14432184, 0.14305145,
    0.14178681, 0.14052798, 0.13927499, 0.1380279, 0.13678673, 0.13555153,
    0.13432235, 0.13309922, 0.13188218, 0.13067127, 0.12946652, 0.12826797,
    0.12707565, 0.12588959, 0.12470983, 0.1235364, 0.12236933, 0.12120864,
    0.12005437, 0.11890653, 0.11776517, 0.11663029, 0.11550194, 0.11438012,
    0.11326486, 0.11215618, 0.1110541, 0.10995865, 0.10886983, 0.10778767,
    0.10671218, 0.10564338, 0.10458128, 0.1035259, 0.10247724, 0.10143532,
    0.10040016, 0.09937175, 0.09835012, 0.09733526, 0.09632719, 0.09532591,
    0.09433142, 0.09334374, 0.09236287, 0.0913888, 0.09042155, 0.08946111,
    0.08850748, 0.08756067, 0.08662067, 0.08568748, 0.0847611, 0.08384153,
    0.08292876, 0.08202278, 0.0811236, 0.08023121, 0.0793456, 0.07846675,
    0.07759468, 0.07672935, 0.07587078, 0.07501894, 0.07417382, 0.07333542,
    0.07250372, 0.07167871, 0.07086037, 0.0700487, 0.06924367, 0.06844527,
    0.06765349, 0.06686832, 0.06608972, 0.06531769, 0.06455221, 0.06379325,
    0.06304081, 0.06229486, 0.06155537, 0.06082234, 0.06009574, 0.05937554,
    0.05866174, 0.05795429, 0.05725318, 0.05655839, 0.0558699, 0.05518767,
    0.05451169, 0.05384192, 0.05317835, 0.05252095, 0.05186969, 0.05122455,
    0.05058549, 0.04995249, 0.04932553, 0.04870457, 0.04808959, 0.04748055,
    0.04687744, 0.04628021, 0.04568884, 0.04510331, 0.04452357, 0.04394961,
    0.04338138, 0.04281886, 0.04226201, 0.04171082, 0.04116523, 0.04062523,
    0.04009077, 0.03956184, 0.03903838, 0.03852038, 0.0380078, 0.0375006,
    0.03699876, 0.03650223, 0.03601099, 0.035525, 0.03504422, 0.03456863,
    0.03409819, 0.03363287, 0.03317262, 0.03271742, 0.03226724, 0.03182203,
    0.03138176, 0.03094639, 0.0305159, 0.03009025, 0.0296694, 0.02925331,
    0.02884195, 0.0284353, 0.0280333, 0.02763593, 0.02724314, 0.02685492,
    0.02647121, 0.02609198, 0.02571721, 0.02534684, 0.02498086, 0.02461921,
    0.02426188, 0.02390881, 0.02355998, 0.02321535, 0.02287489, 0.02253856,
    0.02220632, 0.02187814, 0.02155399, 0.02123383, 0.02091762, 0.02060533,
    0.02029693, 0.01999238, 0.01969165, 0.01939469, 0.01910149, 0.01881199,
    0.01852618, 0.01824401, 0.01796544, 0.01769046, 0.01741902, 0.01715108,
    0.01688662, 0.01662561, 0.016368, 0.01611376, 0.01586287, 0.01561528,
    0.01537097, 0.01512991, 0.01489205, 0.01465738, 0.01442585, 0.01419743,
    0.0139721, 0.01374981, 0.01353055, 0.01331427, 0.01310094, 0.01289055,
    0.01268304, 0.0124784, 0.01227659, 0.01207758, 0.01188134, 0.01168784,
    0.01149706, 0.01130895, 0.0111235, 0.01094067, 0.01076044, 0.01058276,
    0.01040763, 0.010235, 0.01006484, 0.00989714, 0.00973186, 0.00956897,
    0.00940845, 0.00925027, 0.0090944, 0.00894081, 0.00878949, 0.00864039,
    0.00849349, 0.00834878, 0.00820621, 0.00806577, 0.00792743, 0.00779117,
    0.00765695, 0.00752476, 0.00739457, 0.00726635, 0.00714009, 0.00701574,
    0.0068933, 0.00677274, 0.00665403, 0.00653715, 0.00642208, 0.00630879,
    0.00619727, 0.00608748, 0.00597941, 0.00587303, 0.00576833, 0.00566527,
    0.00556384, 0.00546402, 0.00536579, 0.00526911, 0.00517399, 0.00508038,
    0.00498828, 0.00489766, 0.0048085, 0.00472079, 0.0046345, 0.00454961,
    0.0044661, 0.00438396, 0.00430317, 0.0042237, 0.00414554, 0.00406867,
    0.00399308, 0.00391874, 0.00384563, 0.00377375, 0.00370307, 0.00363357,
    0.00356524, 0.00349806, 0.00343202, 0.00336709,
  ],
};
